import { useCallback } from 'react';
import type { TSensitiveDataWarningConfig, TSensitiveDataWarningLogicResult } from './sensitive-data-warning.types';

export const useSensitiveDataWarningLogic = ({ sensitiveDataWarning, toggleSensitiveDataWarning }: TSensitiveDataWarningConfig): TSensitiveDataWarningLogicResult => {
	const isVisible = sensitiveDataWarning.show;

	const handleContinue = useCallback(() => {
		toggleSensitiveDataWarning(false, true);
	}, [toggleSensitiveDataWarning]);

	const handleCancel = useCallback(() => {
		toggleSensitiveDataWarning(false, false);
	}, [toggleSensitiveDataWarning]);

	return { isVisible, handleContinue, handleCancel };
};
